module.exports = __webpack_public_path__ + "static/twitter-d20f5515a63c6bcf574aec5ff65302fd.png";